exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-item-column .input-switcher[data-v-76c0e6a2] {\n  position: absolute;\n  bottom: -8px;\n  left: 13px;\n  font-size: 12px;\n  color: var(--primary-color);\n  cursor: pointer;\n}\ntd[data-v-76c0e6a2] {\n  position: relative;\n  padding: 20px 12px !important;\n}\n", ""]);

// exports
